import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { useEffect, useState } from "react";
import { allApplicant, shorListApp } from "../../services/auth";
import { toastError, toastSuccess } from "../../config/ToastModal";
import { useDispatch } from "react-redux";
import { userJobId } from "../../features/jobapproval/Jobapproval";
import { Link, useNavigate } from "react-router-dom";
const WidgetContentBox = () => {
  const dispatch = useDispatch();
  const router = useNavigate();
  const [allApp, setAllApp] = useState([]);
  const fetchApplicant = async () => {
    try {
      const data = await allApplicant();
      setAllApp(data?.data);
    } catch (error) {
    }
  };
  const viewPage = async (userId, jobId) => {
    if (userId?.length > 0 && jobId?.length > 0) {
      dispatch(userJobId(jobId));
      localStorage.setItem("getId", userId);
      localStorage.setItem("jbId", jobId);
      router(`/viewapplication/?jobId=${jobId}`);
    }
  };
  const statusbtn = async (jobPostId, userId, status) => {
    const data = {
      type: status,
      jobApplyId: jobPostId,
      userId: userId,
    };
    try {
      const { status, message, errors } = await shorListApp(data);
      if (status) {
        toastSuccess(message);
        router("/shortlisted-resumes");
      } else if (message) {
        toastError(message);
      } else if (errors) {
        errors.forEach((err) => toastError(err));
      }
      fetchApplicant();
    } catch (err) {
      toastError("An error occurred while updating status.");
    }
  };

  useEffect(() => {
    fetchApplicant();
  }, []);

  return (
    <div className="widget-content">
      <div className="widget-title d-flex align-items-center">
        <h4>All Candidates</h4>
        <div>
          <div className="form-group col-lg-12 col-md-12 col-xs-12">
            <label>Filter by Status</label>
            <select
              className="chosen-single form-select"
              name="employmentType"
              // value={employmentType}
              // onBlur={handleBlur}
              // onChange={handleChange}
            >
              <option value="" disabled>
                Filter Status
              </option>
              <option value="Full Time">All Candidates</option>
              <option value="Part Time">Short Listed</option>
              <option value="Contract">Rejected</option>
            </select>
            {/* {touched.employmentType && (
              <span className="text-danger">{errors.employmentType}</span>
            )} */}
          </div>
        </div>
      </div>
      <div className="tabs-box">
        <Tabs>
          <div className="tabs-content">
            <TabPanel>
              <div className="row">
                {allApp.map((candidate) => (
                  <div
                    className="candidate-block-three col-lg-6 col-md-12 col-sm-12"
                    key={candidate.id}
                  >
                    <div className="inner-box">
                      <div className="content">
                        <figure
                          className="image"
                          onClick={() =>
                            viewPage(candidate?.userId, candidate?._id)
                          }
                        >
                          <img
                            width={"90px"}
                            height={"90px"}
                            src={candidate.profile}
                            alt="candidates"
                            className="inside-image"
                          />
                        </figure>
                        <h4
                          className="name"
                          onClick={() =>
                            viewPage(candidate?.userId, candidate?._id)
                          }
                        >
                          <Link href={`/viewapplication`}>
                            {candidate.name}
                          </Link>
                        </h4>
                        <ul className="candidate-info">
                          <li className="designation">{candidate.jobTitle}</li>
                          <li>
                            <span className="icon flaticon-map-locator"></span>{" "}
                            {candidate.city}
                          </li>
                          <li>
                            <span className="icon flaticon-money"></span>₹{" "}
                            {candidate.salary}
                          </li>
                        </ul>
                        {/* End candidate-info */}

                        <ul className="post-tags">
                          <li>{candidate.employmentType.replace("_ ", "")}</li>
                        </ul>
                      </div>

                      <div className="option-box">
                        <ul className="option-list">
                          <li>
                            <button
                              data-text="View Aplication"
                              className="d-flex justify-content-center"
                              onClick={() =>
                                viewPage(candidate?.userId, candidate?._id)
                              }
                            >
                              <span className="la la-eye"></span>
                            </button>
                          </li>
                          <li>
                            <button
                              data-text="Approve Aplication"
                              className="d-flex justify-content-center"
                              onClick={() =>
                                statusbtn(
                                  candidate?._id,
                                  candidate?.userId,
                                  "shorted"
                                )
                              }
                            >
                              <span className="la la-check"></span>
                            </button>
                          </li>
                          <li>
                            <button
                              data-text="Reject Aplication"
                              className="d-flex justify-content-center"
                              onClick={() =>
                                statusbtn(
                                  candidate?._id,
                                  candidate?.userId,
                                  "rejected"
                                )
                              }
                            >
                              <span className="la la-times-circle"></span>
                            </button>
                          </li>
                          {/* <li>
                            <button data-text="Delete Aplication"          className="d-flex justify-content-center">
                              <span className="la la-trash"></span>
                            </button>
                          </li> */}
                        </ul>
                      </div>
                    </div>
                  </div>
                ))}

                {allApp?.length === 0 && (
                  <div className="text-center fw-medium fs-5 mt-5 mb-5 d-flex align-items-center justify-content-center">
                    We posted several job openings, but no one applied for the
                    jobs.
                  </div>
                )}
              </div>
            </TabPanel>
          </div>
        </Tabs>
      </div>
    </div>
  );
};

export default WidgetContentBox;
